export const marketUrl = String(process.env.NEXT_PUBLIC_MARKET_URL)
export const marketContractAddress = String(process.env.NEXT_PUBLIC_MARKET_CONTRACT_ADDRESS)
export const vaultSubgraphEndpoint = String(process.env.NEXT_PUBLIC_VAULT_SUBGRAPH_ENDPOINT)
